<div class="route-item" *ngIf="value" [draggable]="true" (dragstart)="onDragStart($event)"
    (click)="clickRoute.emit(value)" (dblclick)="dblClickRoute.emit(value)"
    [style.background-color]="backgroundColor">
    <div class="route-title">{{ value.routeKey }}</div>
    <div class="time marginTime" *ngIf="value.marginTime">
        <i class="fa fa-step-forward" aria-hidden="true"></i>
        {{ value.marginTime | time }}
    </div>
    <div class="time waitingTime" *ngIf="value.waitingTime">
        <i class="fa fa-pause-circle" aria-hidden="true"></i>
        {{ value.waitingTime | time }}
    </div>

    <div class="bottom">
        <shared-slot-viewer-component class="nolocks route-bottom-strip relative element showDock"
            [slotInfo]="value.slotInfo">
        </shared-slot-viewer-component>

        <div class="partner requadre shipper" *ngIf="value.partnerShipperTrademark">{{value.partnerShipperTrademark}}
        </div>
        <div class="partner requadre clientpreferent" *ngIf="value.partnerClientPreferentTrademark">
            {{value.partnerClientPreferentTrademark}}
        </div>
        <div class="partner requadre carrier" *ngIf="value.partnerCarrierTrademark">{{value.partnerCarrierTrademark}}
        </div>
    </div>
    <!--
    <shared-slot-viewer-component *ngIf="slotInfoPhase" class="relative element showDock" [slotInfo]="slotInfoPhase"
        [phaseId]="loadConsoleSlotPhase ? loadConsoleSlotPhase.phaseId : phaseslot.phaseId"
        [lostSlotId]="loadConsoleSlotPhase && loadConsoleSlotPhase.showLostSlotWhenReachedLate ? loadConsoleSlotPhase.lostSlotId : null"
        (callBack)="onCallBack($event)" [slotsMode]="slotsMode">
    </shared-slot-viewer-component>
-->
</div>